import { FormSelect } from '../../../../../../../../components/form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getFrequencyDisplayName } from '../../../utils';
import { Frequency } from '../../constants';

export const FrequencyField = ({ name, required }) => {
    const { t } = useTranslation();

    return (
        <FormSelect
            name={name}
            required={required}
            label={t('sauron.financeModule.payoutProfiles.drawer.fields.frequency.label')}
            placeholder={t('sauron.financeModule.payoutProfiles.drawer.fields.frequency.placeholder')}
            options={[Frequency.WEEKLY, Frequency.SEMIMONTHLY, Frequency.MONTHLY, Frequency.NEVER].map(it => ({
                value: it,
                text: getFrequencyDisplayName(it, { t })
            }))}
        />
    );
};

FrequencyField.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool
};
